class MenuLinks {

	static getMenuLinks(app) {
		var menulinks = [];

		const appconfig = app.getConfig();
		const routesconfig = (appconfig.routes ? appconfig.routes : {});
		const hasquotes = (routesconfig.quotes && (routesconfig.quotes.disabled === true) ? false : true);
		const hasbounties = (routesconfig.bounties && (routesconfig.bounties.disabled === true) ? false : true);
		const hasdeeds = (routesconfig.deeds && (routesconfig.deeds.disabled === true) ? false : true);


		if (hasquotes) {
			menulinks.push({type:'separator'});
			menulinks.push({type:'click', route: 'quote', onclick: () => {this.app.gotoRoute('quote', {action: "create"});}, label: 'Create Quote'});
			menulinks.push({type:'link', route: 'quotes', label: 'Quotes'});
			menulinks.push({type:'link', route: 'orders', label: 'Orders'});
			menulinks.push({type:'link', route: 'invoices', label: 'Invoices'});
			menulinks.push({type:'link', route: 'paymentnotices', label: 'Payment Notices'});
		}

		if (hasbounties) {
			menulinks.push({type:'separator'});
			menulinks.push({type:'click', route: 'bounty', onclick: () => {this.app.gotoRoute('bounty', {action: "create"});}, label: 'Create Bounty'});
			menulinks.push({type:'link', route: 'bounties', label: 'Bounties'});
			menulinks.push({type:'link', route: 'claims', label: 'Claims'});
		}

		if (hasdeeds) {
			menulinks.push({type:'separator'});
			menulinks.push({type:'click', route: 'deed', onclick: () => {this.app.gotoRoute('deed', {action: "create"});}, label: 'Create Deed'});
			menulinks.push({type:'link', route: 'deeds', label: 'Deeds'});
		}

		return menulinks;
	}
}

export default MenuLinks;